// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Table from 'ck-core-client/source/components/Table';
import ProgressBar from 'ck-core-client/source/ui/ReactProgressBar.jsx';

const ProgressTable = props => {
	const { data, headings = [], loading = false, clickable = false } = props;
	const percentageCell = currentRow => (
		<ProgressBar percent={currentRow.original.percentage} showLabel={true} />
	);
	const columns = headings.concat({
		id: 'progress',
		Header: 'Progress',
		accessor: 'percentage',
		minWidth: 250,
		style: clickable ? { cursor: 'pointer' } : {},
		Cell: percentageCell,
		resizable: false
	});
	return (
		<React.Fragment>
			{data &&
				columns && (
					<Table resizable={false} {...props} data={data} columns={columns} loading={loading} />
				)}
		</React.Fragment>
	);
};

ProgressTable.propTypes = {
	data: PropTypes.array.isRequired,
	headings: PropTypes.array.isRequired,
	title: PropTypes.string,
	loading: PropTypes.bool,
	clickable: PropTypes.bool
};

export default ProgressTable;
